import { connect } from 'react-redux'
import { NewGameSettingsDialog } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  return ({
    width,
    user,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewGameSettingsDialog)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/NewGameSettingsDialog.js